import URL_EI from '@/http/rh/entretien/entretien-individuel';
import URL_CO from '@/http/rh/entretien/entretien-collectif';
import URL_C from '@/http/rh/entretien/campagne-entretien';
import CONST from '@/constants/rh/entretien';
export default {
  namespaced: true,
  state: {
    currentEntretienCollectif: null,
    currentEntretienIndividuel: null,
    currentEntretien: null,
    currentCampagne: null,
    employes: [],
    entretienTypes: [],
    edit: false,
    entretienStatuts: [
      { text: CONST.TXT_BROUILLON, value: CONST.BROUILLON },
      { text: CONST.TXT_PLANIFIER, value: CONST.PLANIFIER },
      { text: CONST.TXT_CONFIRMER, value: CONST.CONFIRMER },
      { text: CONST.TXT_REFUSER, value: CONST.REFUSER },
      { text: CONST.TXT_EFFECTUER, value: CONST.EFFECTUER },
    ],
  },

  getters: {
    currentEntretienCollectif: (state) => state.currentEntretienCollectif,
    currentEntretienIndividuel: (state) => state.currentEntretienIndividuel,
    currentEntretien: (state) => state.currentEntretien,
    currentCampagne: (state) => state.currentCampagne,
    employes: (state) => state.employes,
    entretienTypes: (state) => state.entretienTypes,
    edit: (state) => state.edit,
    entretienStatuts: (state) => state.entretienStatuts,
  },

  mutations: {
    SET_EMPLOYES(state, payload) {
      state.employes = payload;
    },

    SET_ENTRETIEN_TYPES(state, payload) {
      state.entretienTypes = payload;
    },

    SET_CURRENT_ENTRETIEN(state, payload) {
      state.currentEntretien = payload;
    },
    SET_CURRENT_CAMPAGNE(state, payload) {
      state.currentCampagne = payload;
    },

    SET_CURRENT_ENTRETIEN_INDIVUDEL(state, payload) {
      state.currentEntretienIndividuel = payload;
    },

    SET_CURRENT_ENTRETIEN_COLLECTIF(state, payload) {
      state.currentEntretienCollectif = payload;
    },
  },

  actions: {
    setEdit({ state }, edit) {
      state.edit = edit;
    },
    setEmployes({ commit }, payload) {
      commit('SET_EMPLOYES', payload);
    },
    setEntretienTypes({ commit }, payload) {
      commit('SET_ENTRETIEN_TYPES', payload);
    },
    setCurrentEntretien({ commit }, payload) {
      commit('SET_CURRENT_ENTRETIEN', payload);
    },

    setCurrentEntretienIndividuel({ commit }, payload) {
      commit('SET_CURRENT_ENTRETIEN_INDIVUDEL', payload);
    },

    setCurrentEntretienCollectif({ commit }, payload) {
      commit('SET_CURRENT_ENTRETIEN_COLLECTIF', payload);
    },
    setCurrentCampagne({ commit }, payload) {
      commit('SET_CURRENT_CAMPAGNE', payload);
    },
    getEntretienIndividuel({ commit }, payload) {
      commit('SET_CURRENT_ENTRETIEN_INDIVUDEL', null);

      if (payload.edit) {
        return window.axios
          .get(URL_EI.ENTRETIEN_INDIVIDUEL + '/' + payload.id, {
            params: { edit: true },
          })
          .then((resp) => {
            commit(
              'SET_CURRENT_ENTRETIEN_INDIVUDEL',
              resp.data.entretien_individuel
            );
          })
          .catch(() => {
            commit('SET_CURRENT_ENTRETIEN_INDIVUDEL', null);
          });
      } else {
        return window.axios
          .get(URL_EI.ENTRETIEN_INDIVIDUEL + '/' + payload.id)
          .then((resp) => {
            commit(
              'SET_CURRENT_ENTRETIEN_INDIVUDEL',
              resp.data.entretien_individuel
            );
          })
          .catch(() => {
            commit('SET_CURRENT_ENTRETIEN_INDIVUDEL', null);
          });
      }
    },
    getEntretienCollectif({ commit }, payload) {
      commit('SET_CURRENT_ENTRETIEN_COLLECTIF', null);

      return window.axios
        .get(URL_CO.ENTRETIEN_COLLECTIF + '/' + payload.id)
        .then((resp) => {
          commit(
            'SET_CURRENT_ENTRETIEN_COLLECTIF',
            resp.data.entretien_collectif
          );
        })
        .catch(() => {
          commit('SET_CURRENT_ENTRETIEN_COLLECTIF', null);
        });
    },
    getCampagne({ commit }, payload) {
      commit('SET_CURRENT_CAMPAGNE', null);

      if (payload.edit) {
        return window.axios
          .get(URL_C.CAMPAGNE_ENTRETIEN + '/' + payload.id, {
            params: { edit: true },
          })
          .then((resp) => {
            commit('SET_CURRENT_CAMPAGNE', resp.data.campagne_entretien);
          })
          .catch(() => {
            commit('SET_CURRENT_CAMPAGNE', null);
          });
      } else {
        return window.axios
          .get(URL_C.CAMPAGNE_ENTRETIEN + '/' + payload.id)
          .then((resp) => {
            commit('SET_CURRENT_CAMPAGNE', resp.data.campagne_entretien);
          })
          .catch(() => {
            commit('SET_CURRENT_CAMPAGNE', null);
          });
      }
    },
  },
};
